<script lang="tsx">
  import { Tooltip } from 'ant-design-vue';
  import { computed, defineComponent } from 'vue';
  import type { PropType } from 'vue';
  import { getNumberTotal } from '@mts-fe/utils';
  import BasicHelp from '@mts/components/Basic/src/BasicHelp.vue';
  import { t } from '@mts/hooks/web/useI18n';
  import { getDataIndex } from '../helper';
  import type { BasicColumn } from '../types/table';

  export default defineComponent({
    name: 'TableHeaderCell',
    components: { BasicHelp },
    props: {
      column: {
        type: Object as PropType<BasicColumn>,
        default: () => ({}),
      },
      dataSource: {
        type: Array as PropType<Recordable[]>,
        default: () => [],
      },
    },
    setup(props) {
      const getTitle = computed(() => {
        const column = props.column;
        if (typeof column.customHeaderRender === 'function') {
          return column.customHeaderRender(column);
        }
        return column?.customTitle || props.column?.title;
      });
      const getHelpMessage = computed(() => props.column?.helpMessage);

      return () => {
        const { dataLangKey, showTotal, customTotal, required } = props.column;
        const dataIndex = getDataIndex(props.column.dataIndex);
        const hasTotal = showTotal && !!props.dataSource.length;
        const totalNum =
          hasTotal &&
          (customTotal?.(props.dataSource, props.column, { t }) ??
            getNumberTotal(props.dataSource, dataIndex));

        return (
          <div field={dataIndex} class={{ 'required-star': required }}>
            <span v-langTips data-lang-key={dataLangKey}>
              {getTitle.value}
            </span>
            {getHelpMessage.value && (
              <BasicHelp text={getHelpMessage.value} placement="top" class="ml-8px" />
            )}
            {hasTotal && (
              <div class="text-[#CC8D00]">
                {!customTotal && typeof totalNum !== 'number' && (
                  <Tooltip title={t('g.25090013')}>-</Tooltip>
                )}
                {totalNum}
              </div>
            )}
          </div>
        );
      };
    },
  });
</script>
